export default __webpack_public_path__ + "static/media/Arrow.edff37d6.svg";